import api from "@/core/services/api.service";
import { athleteService, athleteError } from "@/core/services/athlete.service";

// action types
export const ACREDITATION = "setAcreditation";
export const VERIFY_ACREDITATION = "verifyAcreditation";
//events and sport by institution
export const ACREDITATION_EVENTS = "acreditationEvents";
export const ACREDITATION_SPORTS = "acreditationSports";
//register acreditation
export const REGISTER_ATHLETE = "registerAthlete";
export const REGISTER_ACADEMIC = "registerAcademic";
export const REGISTER_COMPTETITION = "registerCompetition";
export const REGISTER_DOCUMENTATION = "registerDocumentation";
//others
export const RELEASE_ACREDITATION = "releaseAcreditation";
export const LIST_ACREDITATION = "listAcreditation";
export const CONFIG_SPORT = "configSport";
export const TRAEDATA = "traeData";
//update acreditation
export const EDIT_ACREDITATION = "editAcreditation";
export const UPDATE_ATHLETE = "updateAthlete";
export const UPDATE_ACADEMIC = "updateAcademic";
export const UPDATE_COMPETITION = "updateCompetition";
//oficiales
export const OFFICERS_FUNCTIONS = "officersFunctions";
export const OFFICERS_REGISTER = "officersRegister";
export const OFFICERS_LIST = "officersList";

//historial de participacion
export const ATHLETE_HISTORY = "athleteHistory";

export const UBIGEO = "ubigeofdp";

// mutation types
export const SET_ACRED = "dataAcreditation";
export const PURGE_ACRED = "purgeAcreditation";
export const SET_DATALIST = "setDataList";
export const SET_DATAOFFICERS = "setDataOfficers";
export const SET_UBIGEO = "setUbigeo";
export const SET_TRAEDATA = "setTraeData";

const state = {
    acreditation: {},
    acreditationdata: [],
    officers: {
        data: [],
        sumary: []
    },
    ubigeo: [],
    traedata : false
};

const getters = {
    currentAcreditation(state){
        return state.acreditation;
    },
    currentDataListAcrd(state){
        return state.acreditationdata;
    },
    currentDataOfficers(state){
        return state.officers;
    },
    currentUbigeo(state){
        return state.ubigeo;
    },
    isTraeData(state){
        return state.traedata;
    }
};

const actions = {
    [UBIGEO](context, data){
        context.commit(SET_UBIGEO, data);
    },
    [ACREDITATION](context, data){
        context.commit(SET_ACRED, data);
    },
    [TRAEDATA](context, data){
        context.commit(SET_TRAEDATA, data);
    },
    //desfasado
    async [CONFIG_SPORT](context, params){
        return await new Promise(function(resolve, reject){
            api.setHeader();
            api.post(`api/${params.sport}/config`, params.data)
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response);
            })
        });
    },
    async [VERIFY_ACREDITATION](context, params){
        return await new Promise(function(resolve, reject){
            api.setHeader();
            api.post("api/acreditation/verify", params)
            .then(({ data }) => {
                context.commit(SET_ACRED, data);
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response);
            });
        });
    },
    async [REGISTER_ATHLETE](context, params){
        return await new Promise(function(resolve, reject){
            api.setHeader();
            api.post("acr/athlete/save", params)
            .then(({ data }) => {
                context.commit(SET_ACRED, data);
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response);
            });
        });
    },
    async [REGISTER_ACADEMIC](context, params){
        return await new Promise(function(resolve, reject){
            api.setHeader();
            api.post("acr/academic/save", params)
            .then(({ data }) => {
                context.commit(SET_ACRED, data);
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response);
            });
        });
    },
    async [REGISTER_COMPTETITION](context, params){
        return await new Promise(function(resolve, reject){
            api.setHeader();
            api.post("acr/competition/save", params)
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response);
            });
        });
    },
    async [LIST_ACREDITATION](context, params){
        return await new Promise(function(resolve, reject){
            api.setHeader();
            //api.post(`acr/${params.sport}/config` ,"api/acreditation/list-competition", params)
            api.post(`api/${params.sport}`, params.data)
            .then(({ data }) => {
                context.commit(SET_DATALIST, data);
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response);
            })
        });
    },
    async [RELEASE_ACREDITATION](context, id){
        return await new Promise(function(resolve, reject){
            api.setHeader();
            api.delete(`acr/release/${id}`)
            .then(({ data }) => {
                context.commit(SET_ACRED, data);
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response);
            });
        });
    },
    async [EDIT_ACREDITATION](context, id){
        return await new Promise(function(resolve, reject){
            api.setHeader();
            api.get("acr/edit", id)
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response}) => {
                reject(response);
            })
        });
    },
    async [UPDATE_ATHLETE](context, params) {
        return await new Promise(function(resolve, reject) {
            api.setHeader();
            api.update("acr/athlete/update", params.slug, params.data)
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response}) => {
                reject(response);
            })
        });
    },
    async [UPDATE_ACADEMIC](context, params) {
        return await new Promise(function (resolve, reject) {
            api.setHeader();
            api.update("acr/academic/update", params.slug, params.data)
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ response }) => {
                reject(response);
            })
        });
    },
    async [UPDATE_COMPETITION](context, params) {
        return await new Promise((resolve, reject) => {
            api.setHeader();
            api.update("acr/competition/update", params.slug, params.data)
            .then(({ data }) => {resolve(data);})
            .catch(({ response }) => {reject(response);})
        });
    },
    async [ACREDITATION_EVENTS](context) {
        return await new Promise((resolve, reject) => {
            api.setHeader();
            api.get("acr/institution", "events")
            .then(({ data }) => { resolve(data); })
            .catch(({ response }) => { reject(response); });
        });
    },
    async [ACREDITATION_SPORTS](context, id) {
        return await new Promise((resolve, reject) => {
            api.setHeader();
            api.get("acr/institution/sports", id)
            .then(({ data }) => { resolve(data); })
            .catch(({ response }) => { reject(response); });
        });
    },
    async [OFFICERS_FUNCTIONS](context, params) {
        return await new Promise((resolve, reject) => {
            api.setHeader();
            api.post("acr/officers/functions", params)
            .then(({ data }) => { resolve(data); })
            .catch(({ response }) => { reject(response); });
        });
    },
    async [OFFICERS_REGISTER](context, params) {
        return await new Promise((resolve, reject) => {
            api.setHeader();
            api.post("acr/officers/register", params)
            .then(({ data }) => { 
                context.commit(SET_ACRED, data);
                resolve(data); 
            })
            .catch(({ response }) => { reject(response); });
        });
    },
    async [OFFICERS_LIST](context, params) {
        return await new Promise((resolve, reject) => {
            api.setHeader();
            api.post("acr/officers", params)
            .then(({ data }) => {
                context.commit(SET_DATAOFFICERS, data);
                resolve(data); })
            .catch(({ response }) => { reject(response); });
        })
    },
    async [ATHLETE_HISTORY](context, document) {
        return await new Promise((resolve, reject) => {
            api.setHeader();
            api.get("acr/athlete/history", document)
            .then(({ data }) => { resolve(data); })
            .catch(({ response }) => { reject(response); });
        });
    },
};

const mutations = {
    [SET_ACRED](state, payload){
        state.acreditation = payload;
    },
    [PURGE_ACRED](state){
        state.acreditation = {};
    },
    [SET_DATALIST](state, payload){
        state.acreditationdata = payload;
    },
    [SET_DATAOFFICERS](state, payload){
        state.officers = payload;
    },
    [SET_UBIGEO](state, payload){
        state.ubigeo = payload;
    },
    [SET_TRAEDATA](state, payload){
        state.traedata = payload;
    }
};

export default {state, actions, mutations, getters}
